module.exports = __webpack_public_path__ + "static/media/medical_system_1.8b26f2f8.jpg";